import * as React from 'react';
import Select from '@material-ui/core/Select';
import { ChangeEvent, ReactElement, useCallback, useState } from 'react';
import './select-input.css';

type Props = {
  name: string;
};

const StubInput = (props: Props): ReactElement | null => {
  const { name } = props;
  const [value, setValue] = useState<string>();

  const onInputChange = useCallback(
    (ev: ChangeEvent<{ name?: string; value: unknown }>): void => {
      const newValue = Number(ev.target.value);
      setValue(String(newValue));
    },
    []
  );

  return (
    <Select
      className="pw-select"
      native
      value={value}
      onChange={onInputChange}
      fullWidth
      inputProps={{ name, id: name }}
      variant="outlined"
    >
      <option value="1">Option 1</option>
      <option value="2">Option 2</option>
      <option value="3">Option 3</option>
      <option value="4">Option 4</option>
      <option value="5">Option 5</option>
      <option value="6">Option 6</option>
    </Select>
  );
};

export default StubInput;
